import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./scss/main.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ClerkProvider } from "@clerk/clerk-react";
import Dashboard from "./components/dashboard/Dashboard";
import Login from "./components/auth/Login";
import Signup from "./components/auth/Signup";

import firebase from "firebase/compat/app"; // Import Firebase from compat module
import "firebase/compat/auth";
import { firebaseConfig } from "./config/firebase"; // Assuming firebaseConfig.js contains your Firebase config

// For Create React App, environment variables need to be prefixed with REACT_APP_
// For Vite, they use VITE_ prefix, we'll check for both to ensure compatibility
// If the environment variables are not available, fall back to the hardcoded key
const publishableKey =
  process.env.REACT_APP_CLERK_PUBLISHABLE_KEY ||
  process.env.VITE_CLERK_PUBLISHABLE_KEY ||
  "pk_test_cm9tYW50aWMtZ3J1Yi04LmNsZXJrLmFjY291bnRzLmRldiQ";

// Initialize Firebase if not already initialized
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
} else {
  firebase.app();
}

const ClerkWithRoutes = () => {
  return (
    <ClerkProvider publishableKey={publishableKey}>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/dashboard/*" element={<Dashboard />} />
      </Routes>
    </ClerkProvider>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
      <ClerkWithRoutes />
    </HashRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
